import { render, staticRenderFns } from "./BookChartDisease.vue?vue&type=template&id=6c06edd4&"
import script from "./BookChartDisease.vue?vue&type=script&lang=js&"
export * from "./BookChartDisease.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports